module.exports = __webpack_public_path__ + "static/media/viber-social-media-svgrepo-com (1).e6854cc9.svg";